import { RawSiteMap } from '@/services/SiteMapService';
import NavNode, { navNodeFactory } from '@/services/NavigationNode';
import SiteMap from '@/services/SiteMap';

const convertRawToSiteMap = function (raw: RawSiteMap): SiteMap {
	const sm = {
		id: raw.id,
		name: raw.name,
		canHaveChildren: raw.fkSiteMapType === "folderContent"
	};
	return sm;
};

const mapRawSiteMapToNode = function (rsm: RawSiteMap) {
	// create new NavigationNode and set converted SiteMap on it
	const node = navNodeFactory();
	node.siteMap = convertRawToSiteMap(rsm);

	// if the RawSiteMap has children, convert each SiteMap child into NavigationNode
	// recurse
	rsm.children.forEach(function (child) {
		const newNode = mapRawSiteMapToNode(child);
		node.nodes.push(newNode);
	});
	return node;
};

function generateLibrary(data: RawSiteMap[]): NavNode[] {
	const navNodes: NavNode[] = [];

	// convert RawSiteMap into NavigationNode, recursively
	data.forEach((rawSm) => {
		navNodes.push(mapRawSiteMapToNode(rawSm));
	});

	return navNodes;
}

export {
	generateLibrary
};